export default class DataManipulationUtils {
  static decordJwtToken (jwtToken) {
    var base64Url = jwtToken.split('.')[1]
    var base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64))
  }
}
